import { ReactNode } from 'react';

interface ProviderStatTileProps {
  icon: ReactNode;
  value: ReactNode;
  label: string;
  /** Optional small suffix shown next to the value, e.g. a review count. */
  valueSuffix?: string;
}

/**
 * One bordered stat tile: pale-cyan icon chip on the left, big value + label.
 * Tiles are only mounted by the caller when real data backs them.
 */
const ProviderStatTile = ({
  icon,
  value,
  label,
  valueSuffix,
}: ProviderStatTileProps) => (
  <div className="flex items-center gap-3 rounded-2xl border border-border bg-white p-4">
    <span
      aria-hidden="true"
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brandpalecyan/30 text-brandOcean"
    >
      {icon}
    </span>
    <div className="min-w-0">
      <p className="flex items-baseline gap-1 text-xl font-bold leading-tight text-brandnavy">
        {value}
        {valueSuffix && (
          <span className="text-xs font-medium text-gray-500">
            {valueSuffix}
          </span>
        )}
      </p>
      <p className="truncate text-xs text-gray-500">{label}</p>
    </div>
  </div>
);

export default ProviderStatTile;
